import * as actions from './expenseBill/actions'
import * as mutations from './expenseBill/mutations'
import * as getters from './expenseBill/getters'

import { dataProps } from './expenseBill/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.bill_date',
        sort_direction: 1, search: ''
    },
    outstanding_list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/expenseBill.js